<template>
    <div class="row justify-center " style="min-width: 800px;min-height: 95vh">
        <div class="card q-pa-md">

            <h4 class="mt-0 mb-3 text-left" style="font-size: 26px; font-weight: 300">
                Verify Email
            </h4>
            <div class="mb-3">
                <span :style="'font-size: 18px;'">We have sent you a verification code on your Email ID</span>
            </div>
            <div class="mb-4">
                <span class="text-bold" :style="'font-size: 16px;'">{{ user.organization.email }}</span>
            </div>

            <div class="mb-3 mt-3">
                <span class="text-bold" :style="'font-size: 16px; color: #105992;'">Enter a Verification Code</span>
            </div>
            <q-form ref="form">
                <div class="row q-col-gutter-sm d-flex justify-center">
                    <div class="col-1">
                        <q-input ref="code0Input" @input="handleInput('code1', code0)" class="searchBox pl-4 my-3" mask="#"
                            lazy-rules v-model="code0">
                        </q-input>
                    </div>

                    <div class="col-1">
                        <q-input ref="code1Input" @input="handleInput('code2', code1)" class="searchBox pl-4 my-3" mask="#"
                            lazy-rules v-model="code1">
                        </q-input>
                    </div>

                    <div class="col-1">
                        <q-input ref="code2Input" @input="handleInput('code3', code2)" class="searchBox pl-4 my-3" mask="#"
                            lazy-rules v-model="code2">
                        </q-input>
                    </div>

                    <div class="col-1">
                        <q-input ref="code3Input" @input="handleInput('code4', code3)" class="searchBox pl-4 my-3" mask="#" lazy-rules v-model="code3" style="text-align: center;">
                            <input type="text" id="f_29a102af-b3eb-4297-8584-9ceb2a64c433" class="q-field__native q-placeholder" >
                        </q-input>
                    </div>
                </div>
                <div class="col-12 w-100">
                    <div class="position-relative w-100" style="margin-left: -16px;">
                        <div class="app-fixed-footer w-100" style="padding-left: 14px; bottom: 20px;">
                            <div class="d-flex " style="justify-content: left">
                                <q-btn @click="verifyOTP('form')" class="pd-btn  my-3" :disable="isDisableVerify">Verify
                                </q-btn>
                                <q-btn @click="closeDialog" class=" my-3 ml-3" color="primary">CANCEL</q-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </q-form>
            <div @click="resendOTP" class="mb-3 mt-3 cursor-pointer">
                <span class="text-bold" :style="'font-size: 16px; color: #167E85;'">Resend OTP</span>
            </div>
        </div>
    </div>
</template>
    
<script>
import axios from 'axios';
import Constants from '../../Constants/Constant';


export default {
    name: 'EditEmail',
    props: {
        verificationId: String,
    },

    data: function () {
        return {
            code0: '',
            code1: '',
            code2: '',
            code3: '',
            verificationIdData: '',
            user: JSON.parse(localStorage.getItem('user')),
            loggedIn_partnerType: JSON.parse(localStorage.getItem('user')).organization.partnerType,
            emailPattern: new RegExp(
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
        }
    },
    created() {
        this.verificationIdData = this.verificationId
    },
    mounted() {

    },
    computed: {
        isDisableVerify() {
            if (this.code0 == '' || this.code1 == '' || this.code2 == '' || this.code3 == '') {
                return true;
            } return false;
        }
    },
    methods: {
        handleInput(nextInput, value) {
            let currentValue = '';
            if (nextInput == 'code1') {
                currentValue = this.code0;
            }
            if (nextInput == 'code2') {
                currentValue = this.code1;
            }
            if (nextInput == 'code3') {
                currentValue = this.code2;
            }

            if (nextInput == 'code4') {
                currentValue = this.code3;
            }

            if(currentValue == '') {
                if (nextInput == 'code4') {
                    this.$refs['code2Input'].focus();
                }

                if (nextInput == 'code3') {
                    this.$refs['code1Input'].focus();
                }

                if (nextInput == 'code2') {
                    this.$refs['code0Input'].focus();
                }
            }
            if (currentValue && currentValue.length === 1) {
                this.$refs[nextInput + 'Input'].focus();
            }
        },

        closeDialog() {
            this.$emit('closeVerifyEmailDialog', false)
        },

        async resendOTP() {
            const apiUrl = Constants.api_url + 'sendOTPVerifyEmail';
            try {
                const request = {
                    orgId: this.user.organization.id,
                    userId: this.user.id,
                    email: this.user.organization.email
                }
                const response = await axios.post(apiUrl, request);
                if (response && response.data) {
                    this.verificationIdData = response.data.data.id;
                    this.$q.notify({
                        position: 'top-right',
                        message: `OTP sent on your Email successfully.`,
                    });
                }
            } catch (error) {
                console.error("Error in resend OTP", error);
            }
        },

        async verifyOTP(name) {
            this.$refs[name].validate().then(async (success) => {
                if (success) {
                    const apiUrl = Constants.api_url + 'verifyOtpToVerifyEmail';
                    try {
                        const otpNumber = `${this.code0}${this.code1}${this.code2}${this.code3}`
                        const request = {
                            id: this.verificationIdData,
                            otp: otpNumber
                        }
                        const response = await axios.post(apiUrl, request);
                        if (response && response.data) {
                            if (response.data.flag == true) {
                                this.$q.notify({
                                    position: 'top-right',
                                    message: `Your Email Verified successfully.`,
                                });
                                this.$emit('closeVerifyEmailDialog', false);
                            }
                            if (response.data.flag == false) {
                                this.$q.notify({
                                    position: 'top-right',
                                    message: `Invalid OTP`,
                                });
                            }
                        }
                    } catch (error) {
                        console.error("Error in Verify Email", error);
                    }
                } else {
                    this.$q.notify({
                        position: 'top-right',
                        message: `Please review the form errors highlighted in red.`,
                    });
                }
            })
        }
    }
}
</script>
    
<style scoped>
.card {
    text-align: center;
    width: 100%;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: bottom;
    border-radius: 4px;
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
    position: relative;
}

.section-title {
    font-weight: bolder;
    font-size: 16px;
}

.bank-card {
    margin-top: 7px;
}

.card-close-icon {
    margin: -24px -17px 0 0;
}

.searchBox {
    background: #f2f2f2;
    height: 50px;
    border-radius: 7px;
    padding: 0px;
    transition: 0.3s;
}

/deep/ .q-field--outlined .q-field__control {
    padding: 0px !important;
}
</style>
    